module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [(!_vm.microNote) ? _vm._c('LoadingIndicator') : (!_vm.microNote.micro_note_images || _vm.microNote.micro_note_images.length <= 0) ? _vm._c('div', [_vm._c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._c('span', {
    staticClass: "icon mdi mdi-close-circle-o"
  }), _vm._v(" Failed to load micro note image\n    ")])]) : _vm._c('div', [_vm._c('div', {
    staticClass: "image-container",
    class: {
      creating: _vm.dragCoords
    }
  }, [(_vm.newKeyword) ? _vm._c('ImageKeyword', {
    attrs: {
      "scale": _vm.scale,
      "keyword": _vm.newKeyword
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.newKeywordsArray), function(keyword) {
    return _vm._c('ImageKeyword', {
      attrs: {
        "activeKeywordId": _vm.activeKeywordId,
        "onDelete": _vm.handleDeleteKeyword,
        "onUpdate": _vm.handleUpdateKeyword,
        "onClick": _vm.handleKeywordClick,
        "scale": _vm.scale,
        "keyword": keyword
      }
    })
  }), _vm._v(" "), _vm._c('img', {
    ref: "image",
    attrs: {
      "src": _vm.microNote.micro_note_images[0].image_url
    },
    on: {
      "mousedown": [function($event) {
        $event.preventDefault();
        _vm.createKeywordStart($event)
      }, function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return; }
        _vm.handleImageClick($event)
      }]
    }
  })], 2), _vm._v(" "), _vm._c('p', {
    staticClass: "text-muted xs-mt-20"
  }, [_vm._v(_vm._s(_vm.statusMessage))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c2b071b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/micro-note-editor/MicroNoteImageEditor.vue
// module id = 677
// module chunks = 1